import {QueryClient} from 'react-query';
import {isAxiosError} from 'axios';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (failureCount >= 3) {
          return false;
        }
        if (!isAxiosError(error)) {
          return false;
        }
        if (isAxiosError(error)) {
          const statusCode = error.response?.status;
          if (!statusCode) {
            return true;
          }
          if (statusCode <= 500) {
            return false;
          }
          return true;
        }
        return true;
      },
    },
  },
});
